export const MODULE_LIST = ['screener', 'rsl_backtest', 'depot', 'trade_journal', 'kontoauszug', 'academy', 'support', 'signals', 'index_invest', 'custom_rsl_watchlists'];

export const PLAN_MODULE_MATRIX_ROWS = [
  { module: 'start', label: 'Start' },
  { module: 'depot', label: 'Depot' },
  { module: 'screener', label: 'Scanner' },
  { module: 'rsl_backtest', label: 'Backtest' },
  { module: 'trade_journal', label: 'IB-Journal' },
  { module: 'kontoauszug', label: 'IB-Auswertung' },
  { module: 'coaching', label: 'Anleitung' },
  { module: 'academy', label: 'Automation' },
  { module: 'signals', label: 'Signale' },
  { module: 'index_invest', label: 'Index-Invest' },
  { module: 'custom_rsl_watchlists', label: 'Eigene RSL-Watchlisten' },
  { module: 'support', label: 'Support' },
  { module: 'konto', label: 'Profil' },
];

export const SUPPORT_CATEGORIES = [
  'Allgemeine Frage',
  'Login & Zugang',
  'Abo & Rechnung',
  'RSL-Scanner',
  'RSL-Depot',
  'RSL-Backtest',
  'Index-Invest',
  'Trading-Journal',
  'Technisches Problem',
  'Feedback & Wunsch',
];
export const SUPPORT_STATUSES = ['offen', 'in_bearbeitung', 'beantwortet', 'geschlossen'];
export const SIGNAL_KINDS = ['open', 'close'];

export const RSL_WEEKDAYS = [
  { id: 'mon', label: 'Montag' },
  { id: 'tue', label: 'Dienstag' },
  { id: 'wed', label: 'Mittwoch' },
  { id: 'thu', label: 'Donnerstag' },
  { id: 'fri', label: 'Freitag' },
  { id: 'sat', label: 'Samstag' },
  { id: 'sun', label: 'Sonntag' },
];

export const VIEW_PATHS = {
  start: '/start',
  screener: '/rsl-screener',
  rsl_backtest: '/rsl-backtest',
  depot: '/mein-depot',
  rsl_journal: '/rsl-journal',
  trade_journal: '/trade-journal',
  kontoauszug: '/ib-auswertung',
  coaching: '/anleitung',
  academy: '/automation',
  support: '/ticket-support',
  signals: '/signale',
  index_invest: '/index-invest',
  admin: '/admin-panel',
  konto: '/konto',
};

export function getPathForView(view) {
  return VIEW_PATHS[view] || '/start';
}

export function getViewFromPathname(pathname) {
  const normalized = pathname && pathname !== '' ? pathname : '/';
  if (normalized === '/') return 'start';
  if (normalized === '/bibliothek') return 'academy';
  if (normalized === '/coaching') return 'coaching';
  const match = Object.entries(VIEW_PATHS).find(([, path]) => path === normalized);
  return match ? match[0] : 'start';
}

export const PLAN_LIST = ['free', 'basic', 'premium'];
export const PLAN_STATUS_LIST = ['trial', 'active', 'canceled', 'expired'];

export const PLAN_FEATURES = [
  {
    label: 'RSL-Scanner: Indexes',
    free: '- S&P500\n- DAX 100\n- Nasdaq 100\n- Euro STOXX 600',
    basic: '- S&P500\n- DAX 100',
    premium: '- S&P500\n- DAX 100\n- Nasdaq 100\n- Euro STOXX 600',
  },
  { label: 'RSL-Scanner: Anzahl Top-Titel', free: '10', basic: '20', premium: 'Alle Titel im Index' },
  { label: 'RSL-Depot', free: true, basic: true, premium: true },
  {
    label: 'RSL-Journal',
    free: '- Auswertung\n- Grafik',
    basic: '- Auswertung\n- Grafik',
    premium: '- Auswertung\n- Grafik\n- Export als CSV',
  },
  {
    label: 'RSL-Backtest',
    free: '- S&P500\n- DAX 100\n- Nasdaq 100\n- Euro STOXX 600',
    basic: '- S&P500\n- DAX 100',
    premium: '- S&P500\n- DAX 100\n- Nasdaq 100\n- Euro STOXX 600\n\nExport als CSV',
  },
  {
    label: 'Index-Invest',
    free: false,
    basic: true,
    premium: '✓\n\nExport als CSV',
  },
  { label: 'Depotstatus per E-Mail', free: 'Mo-So auswählbar', basic: 'montags', premium: 'Mo-So auswählbar' },
  { label: 'Support mit Ticket-System', free: true, basic: true, premium: true },
  { label: 'Zugang zur Telegram-Community', free: true, basic: true, premium: true },
  { label: 'Trade-Automation (IB/TWS)', free: false, basic: false, premium: '✓ (im Aufbau)' },
  { label: 'Preis pro Monat', free: '30 Tage kostenlos', basic: '30 Tage kostenlos, danach 29 EUR', premium: '39 EUR' },
];

export const FEATURE_TOOLTIPS = {
  'RSL-Scanner: Indexes': 'Übersichtlicher und täglich aktualisierter Screener mit den je Plan verfügbaren Indexes.',
  'RSL-Scanner: Anzahl Top-Titel': 'Anzahl der im Scanner angezeigten Top-Titel pro Markt.',
  'RSL-Depot': 'Persönliches RSL-Depot zur Verwaltung der ausgewählten Titel inklusive Signalen und Performance-Überblick.',
  'RSL-Journal': 'Auswertung Deiner geschlossenen und offenen Positionen, optional mit CSV-Export.',
  'RSL-Backtest': 'Historische Strategieauswertung je Markt, in Plus zusätzlich mit CSV-Export.',
  'Index-Invest': 'Regelbasierte Index-Invest-Übersicht. In Plus zusätzlich mit CSV-Export.',
  'Depotstatus per E-Mail': 'E-Mail-Versand des aktuellen Depotstatus gemäß Planumfang.',
  'Support mit Ticket-System': 'Schreibe bei Fragen, Problemen, Anregungen direkt an unser Team.',
  'Trade-Automation (IB/TWS)': 'Automation im Plus-Bereich (aktuell im Aufbau).',
};
